import React from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { Box, HStack, Text, VStack, Divider } from '@chakra-ui/react'
import numeral from 'numeral'
import { useUserRolesSelector } from 'utils/redux-common-selectors'

export const EstimateTotalInfo: React.FC = (props: any) => {
  const { isVendor } = useUserRolesSelector()
  const { control } = useFormContext()

  const laborCost = useWatch({ control, name: 'laborCost' })
  const materialCost = useWatch({ control, name: 'materialCost' })

  const vendorLaborCost = laborCost.reduce((a, i) => {
    return a + i.itemVendorRate
  }, 0)

  const clientLaborCost = laborCost.reduce((a, i) => {
    return a + i.itemClientRate
  }, 0)

  // const clientMaterialCost = materialCost.reduce((a, i) => {
  //   return a + (i.itemCost + (i.itemCost * i.itemClientRate) / 100)
  // }, 0)

  const clientMaterialCost = materialCost.reduce( (a, i) => a+i.itemAmount , 0 );
  const vendorMaterialCost = materialCost.reduce((a, i) => {
    return a + i.itemCost
  }, 0)

  const vendorTotalCost = Number(vendorLaborCost) + Number(vendorMaterialCost)
  const clientTotalCost = Number(clientLaborCost) + Number(clientMaterialCost)

  return (
    <Box>
      <HStack justifyContent="end" padding="20px" paddingBottom="10px" gap="25px">
        <Box>
          <Text fontSize="20px" fontWeight="500" color="#4A5568">
            Total:
          </Text>
        </Box>
        <Box>
          <VStack>
            <Text fontSize="10px" color="#718096" fontWeight="400">
              Vendor Cost
            </Text>
            <Text fontSize="20px" fontWeight="500" color="#4A5568">
              {numeral(vendorTotalCost || '0').format('$0,0.00')}
            </Text>
          </VStack>
        </Box>
        {!isVendor && (
          <>
            <Divider orientation="vertical" height="30px" border="1px solid #CBD5E0" />
            <Box>
              <VStack>
                <Text fontSize="10px" color="#718096" fontWeight="400">
                  Client Amount
                </Text>
                <Text fontSize="20px" fontWeight="500" color="#4A5568">
                  {numeral( clientTotalCost || '0').format('$0,0.00')}
                </Text>
              </VStack>
            </Box>
          </>
        )}
      </HStack>
    </Box>
  )
}
